<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['patient_payments']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <!-- Advanced Filters Section -->
              <div class="row mb-3">
                <div class="col-md-3 px-1">
                  <label class="form-label">Date Range</label>
                  <div class="d-flex gap-2">
                    <input v-model="datefrom" type="date" class="form-control" placeholder="From">
                    <input v-model="dateto" type="date" class="form-control" placeholder="To">
                  </div>
                </div>
                <div class="col-md-3 px-1">
                  <label class="form-label">Amount Paid Range</label>
                  <div class="d-flex gap-2">
                    <input type="number" v-model="filters.paidMin" class="form-control" placeholder="Min Paid">
                    <input type="number" v-model="filters.paidMax" class="form-control" placeholder="Max Paid">
                  </div>
                </div>
                <div class="col-md-3 px-1">
                  <label class="form-label">Discount Range</label>
                  <div class="d-flex gap-2">
                    <input type="number" v-model="filters.discountMin" class="form-control" placeholder="Min Discount">
                    <input type="number" v-model="filters.discountMax" class="form-control" placeholder="Max Discount">
                  </div>
                </div>
                <div class="col-md-3 ps-1">
                  <label class="form-label">Balance Range</label>
                  <div class="d-flex gap-2">
                    <input type="number" v-model="filters.balanceMin" class="form-control" placeholder="Min Balance">
                    <input type="number" v-model="filters.balanceMax" class="form-control" placeholder="Max Balance">
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="d-flex align-items-end">
                  <button class="btn btn-secondary me-2" @click="clearFilters">
                    <i class="mdi mdi-filter-remove"></i> Clear Filters
                  </button>
                  <button class="btn btn-info me-2" @click="applyFilters">
                    <i class="mdi mdi-filter"></i> Apply Filters
                  </button>
                  <button class="btn btn-danger" @click="exportToPDF">
                    <i class="mdi mdi-file-pdf"></i> Export PDF
                  </button>
                </div>
              </div>

              <hr />

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <b-table
                  :items="filteredItems"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                  striped
                  hover
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ (currentPage - 1) * perPage + data.index + 1 }}
                </template>
                <template #cell(patient_id)="data">
                  {{ data.item.patient.patient_id }}
                </template>
                <template #cell(name)="data">
                  <b>{{ data.item.patient.name }}</b><br>
                  <small>0{{ data.item.patient.telephone }}</small>
                </template>
                <template #cell(prescription)="data">
                  {{ formatCurrency(data.item.prescriptions) }}
                </template>
                <template #cell(consumables)="data">
                  {{ formatCurrency(data.item.consumables) }}
                </template>
                <template #cell(paid)="data">
                  {{ formatCurrency(data.item.paid) }}
                </template>
                <template #cell(discount)="data">
                  {{ formatCurrency(data.item.discount) }}
                </template>
                <template #cell(total_amount)="data">
                  {{ formatCurrency(data.item.total_amount) }}
                </template>
                <template #cell(services)="data">
                  <div class="btn-group">
                    <router-link :to="{ path: '/ledger',  query: { id: data.item.id }}" type="button" class="btn-sm btn btn-dark"> ledger</router-link>
                  </div>
                </template>
                <template #cell(balance)="data">
                  <span v-if="data.item.balance>0">
                  {{ formatCurrency(data.item.balance) }} <br>
                    <b-button @click="pay(data.item.id,data.item.patient.patient_id,data.item.patient.name,data.item.patient.gender,data.item.patient.telephone,data.item.balance,data.item.patient.patient_id,data.item.visit_id,data.item.discount)" type="button" class="btn-sm btn" variant="primary" v-b-modal.view-pay> <i class="mdi mdi-cash"></i> pay</b-button>
                  </span>
                  <span v-else class="text-primary">
                      <i class="fas fa-check"></i> Paid
                  </span>
                </template>
                </b-table>
              </div>

              <!-- Statistics Section -->
              <div class="mt-4">
                <div class="row">
                  <div class="col-md-6">
                    <div class="card bg-light">
                      <div class="card-body">
                        <h5 class="card-title text-primary">Summary Statistics</h5>
                        <div class="row">
                          <div class="col-md-6">
                            <p><strong>Total Records:</strong> {{ filteredListLength }}</p>
                            <p><strong>Total Service Amount:</strong> {{ formatCurrency(statistics.totalServices) }}</p>
                            <p><strong>Total Prescriptions:</strong> {{ formatCurrency(statistics.totalPrescriptions) }}</p>
                            <p><strong>Total Consumables:</strong> {{ formatCurrency(statistics.totalConsumables) }}</p>
                          </div>
                          <div class="col-md-6">
                            <p><strong>Total Amount:</strong> {{ formatCurrency(statistics.totalAmount) }}</p>
                            <p><strong>Total Paid:</strong> {{ formatCurrency(statistics.totalPaid) }}</p>
                            <p><strong>Total Discounts:</strong> {{ formatCurrency(statistics.totalDiscounts) }}</p>
                            <p><strong>Total Balance:</strong> {{ formatCurrency(statistics.totalBalance) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card bg-success text-white">
                      <div class="card-body">
                        <h5 class="card-title">Financial Summary</h5>
                        <p><strong>Highest Payment:</strong> {{ formatCurrency(statistics.maxPaid) }}</p>
                        <p><strong>Highest Balance:</strong> {{ formatCurrency(statistics.maxBalance) }}</p>
                        <p><strong>Collection Rate:</strong> {{ statistics.collectionRate }}%</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="filteredListLength" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Patients Payments</span></center>
          </div>
        </div>
      </div>
    </div>

    <!-- Payment Modal -->
    <b-modal id="view-pay" centered title="Patient Payment" title-class="font-14" hide-footer>
      <h6 class="text-dark"> Name : <span class="text-primary me-5">{{ name }}</span>
       Telephone : <span class="text-primary">0{{ telephone }}</span></h6>
       <form @submit.prevent="addPayment">
            <input v-model="patient_id" type="hidden"/>
            <input v-model="visit_id" type="hidden"/>
            <div class="form-group mb-2">
              <label>Total Amount</label>
              <input v-model="amount_compute" readonly type="number" class="form-control"/>
             </div>
             <div class="form-group mb-2">
              <label>Discount</label>
              <input v-model="amount_discount" @input="FilterPrice" type="number" class="form-control"/>
              </div>
                <div class="form-group mb-2">
              <label>Amount Paid</label>
              <input v-model="amount_paid" @input="FilterPrice" type="number" class="form-control" />
              </div>
            <div class="form-group mb-2">
              <label>Payment Type</label>
              <b-form-select class="form-control" @change="CheckPayType" v-model="payment_type">
                <option value="1">Cash</option>
                <option value="3">Personal Account</option>
              </b-form-select>
            </div>
            <div class="form-group mb-2" v-show="showaccountbalance">
              <label>Account Balance</label>
              <input v-model="account_balance" readonly type="number" class="form-control" />
            </div>
            <div v-show="showpaymethod" class="form-group mb-2">
            <label>Payment Method</label>
            <multiselect v-model="payment_method" :options="paymentoptions" label="name"></multiselect>
            </div>
            <div class="form-group mb-2">
            <label>Pay Date</label>
            <input v-model="paydate" type="date" class="form-control"/>
            </div>
            <br><span class="text-danger">{{ error }}</span>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('view-pay')" >Close</b-button>
                <b-button type="submit" :disabled="balancebtn <= false" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { paymentoptionComputed, paymentoptionMethods, patientpaymentMethods, patientpaymentComputed } from "@/state/helpers";

export default {
  page: {
    title: "Patient Payments",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader,Multiselect
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Patient Payments",
      items: [ {text: "Dashboard",to: "/",}, {text: "Patient Payments",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      filterOn: ['patient.name', 'patient.telephone', 'patient.patient_id'],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true, sortable: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true, sortable: true },
          { key: 'total_amount', label: 'Service Amount', visible: true, sortable: true },
          { key: 'prescription', label: 'Prescription', visible: true, sortable: true },
          { key: 'consumables', label: 'Consumables', visible: true, sortable: true },
          { key: 'paid', label: 'Amount Paid', visible: true, sortable: true },
          { key: 'discount', label: 'Discount', visible: true, sortable: true },
          { key: 'balance', label: 'Balance', visible: true, sortable: true },
          { key: 'visit_date', label: 'Visit Date', visible: true, sortable: true },
          { key: 'services', label: 'Details', visible: true },
        ],
      services:[],
      visitID:'',
      id:'',
      telephone:'',
      name:'',
      gender:'',
      patient_id:'',
      visit_id:'',
      payment_method:'',
      payment_type:"1",
      amount_paid:'', 
      amount_discount:'',
      paydate:new Date().toLocaleDateString('fr-CA'),
      showaccountbalance:false,
      account_balance:0,
      balancebtn:true,
      showpaymethod:true,
      error:'',
      datefrom: new Date().toLocaleDateString('fr-CA'),
      dateto: new Date().toLocaleDateString('fr-CA'),
      amount_compute:0,
      
      // Advanced filters
      filters: {
        paidMin: '',
        paidMax: '',
        discountMin: '',
        discountMax: '',
        totalMin: '',
        totalMax: '',
        balanceMin: '',
        balanceMax: '',
        patientName: '',
        telephone: ''
      },
      appliedFilters: {}
    };
  }, 
  computed: {
    ...patientpaymentComputed,
    ...paymentoptionComputed,
    List() { return this.patientpayments.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.patientpayments.map((d) => ({...d }))},
    IsBusy() { return this.patientpayments.length === 0 },
    
    // Filtered items based on advanced filters
    filteredItems() {
      let items = [...this.patientpayments];
      
      // Date range filter
      if (this.appliedFilters.datefrom && this.appliedFilters.dateto) {
        items = items.filter(item => {
          const visitDate = new Date(item.visit_date);
          const fromDate = new Date(this.appliedFilters.datefrom);
          const toDate = new Date(this.appliedFilters.dateto);
          return visitDate >= fromDate && visitDate <= toDate;
        });
      } else if (this.appliedFilters.datefrom) {
        items = items.filter(item => new Date(item.visit_date) >= new Date(this.appliedFilters.datefrom));
      } else if (this.appliedFilters.dateto) {
        items = items.filter(item => new Date(item.visit_date) <= new Date(this.appliedFilters.dateto));
      }
      
      // Amount paid range
      if (this.appliedFilters.paidMin) {
        items = items.filter(item => item.paid >= parseFloat(this.appliedFilters.paidMin));
      }
      if (this.appliedFilters.paidMax) {
        items = items.filter(item => item.paid <= parseFloat(this.appliedFilters.paidMax));
      }
      
      // Discount range
      if (this.appliedFilters.discountMin) {
        items = items.filter(item => item.discount >= parseFloat(this.appliedFilters.discountMin));
      }
      if (this.appliedFilters.discountMax) {
        items = items.filter(item => item.discount <= parseFloat(this.appliedFilters.discountMax));
      }
      
      // Total amount range
      if (this.appliedFilters.totalMin) {
        items = items.filter(item => item.total_amount >= parseFloat(this.appliedFilters.totalMin));
      }
      if (this.appliedFilters.totalMax) {
        items = items.filter(item => item.total_amount <= parseFloat(this.appliedFilters.totalMax));
      }
      
      // Balance range
      if (this.appliedFilters.balanceMin) {
        items = items.filter(item => item.balance >= parseFloat(this.appliedFilters.balanceMin));
      }
      if (this.appliedFilters.balanceMax) {
        items = items.filter(item => item.balance <= parseFloat(this.appliedFilters.balanceMax));
      }
      
      // Patient name filter
      if (this.appliedFilters.patientName) {
        items = items.filter(item => 
          item.patient.name?.toLowerCase().includes(this.appliedFilters.patientName.toLowerCase())
        );
      }
      
      // Telephone filter
      if (this.appliedFilters.telephone) {
        items = items.filter(item => 
          item.patient.telephone?.includes(this.appliedFilters.telephone)
        );
      }
      
      return items;
    },
    
    filteredListLength() {
      return this.filteredItems.length;
    },
    
    // Comprehensive statistics
    statistics() {
      const items = this.filteredItems;
      const totalServices = items.reduce((sum, item) => sum + (item.total_amount || 0), 0);
      const totalPrescriptions = items.reduce((sum, item) => sum + (item.prescriptions || 0), 0);
      const totalConsumables = items.reduce((sum, item) => sum + (item.consumables || 0), 0);
      const totalAmount = totalServices + totalPrescriptions + totalConsumables;
      const totalPaid = items.reduce((sum, item) => sum + (item.paid || 0), 0);
      const totalDiscounts = items.reduce((sum, item) => sum + (item.discount || 0), 0);
      const totalBalance = items.reduce((sum, item) => sum + (item.balance || 0), 0);
      
      const paidAmounts = items.map(item => item.paid).filter(v => v > 0);
      const discounts = items.map(item => item.discount).filter(v => v > 0);
      const balances = items.map(item => item.balance);
      
      return {
        totalServices,
        totalPrescriptions,
        totalConsumables,
        totalAmount,
        totalPaid,
        totalDiscounts,
        totalBalance,
        averagePayment: paidAmounts.length ? totalPaid / paidAmounts.length : 0,
        averageDiscount: discounts.length ? totalDiscounts / discounts.length : 0,
        maxPaid: paidAmounts.length ? Math.max(...paidAmounts) : 0,
        maxBalance: balances.length ? Math.max(...balances) : 0,
        collectionRate: totalAmount > 0 ? ((totalPaid / totalAmount) * 100).toFixed(2) : 0
      };
    }
  },
  mounted() {
    this.fetchPatientPayments();
    this.fetchPaymentoptions();
    this.TotalRows = this.patientpayments.length;
    this.isBusy = false;
    this.payment_method = this.paymentoptions.find(option => option.set_default == 1);
  },
  methods: {
    ...patientpaymentMethods,
    ...paymentoptionMethods,
    
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    
    FilterData() { 
      this.filters.datefrom = this.datefrom;
      this.filters.dateto = this.dateto;
      this.applyFilters();
    },
    
    formatCurrency(x) {
      if (!x && x !== 0) return '0';
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(x);
    },
    
    commas(x) { 
      return this.formatCurrency(x);
    },
    
    applyFilters() {
      this.appliedFilters = { 
        ...this.filters,
        datefrom: this.datefrom,
        dateto: this.dateto
      };
      this.currentPage = 1;
    },
    
    clearFilters() {
      this.filters = {
        paidMin: '',
        paidMax: '',
        discountMin: '',
        discountMax: '',
        totalMin: '',
        totalMax: '',
        balanceMin: '',
        balanceMax: '',
        patientName: '',
        telephone: ''
      };
      this.datefrom = new Date().toLocaleDateString('fr-CA');
      this.dateto = new Date().toLocaleDateString('fr-CA');
      this.appliedFilters = {};
      this.currentPage = 1;
    },
    
    async CheckPayType(){
      if (this.payment_type=='3') {
        let url = `/checkpaytype/${this.patient_id}`;
        await axios.get(url).then((response) => {
          this.account_balance = response.data.balance;
          this.showaccountbalance=true;
          this.showpaymethod=false;
          this.FilterPrice();
        });
      } else {
        this.balancebtn=true;
        this.showaccountbalance=false;
        this.showpaymethod=true;
        this.error='';
      }
    },
    
    async FilterPrice() {
      if (this.payment_type === '3') {
        this.showpaymethod = false;
        this.balance = this.account_balance - this.amount_paid - this.amount_discount;
        
        if (this.balance < 0) {
          this.balancebtn = false;
          this.error = "Insufficient Balance";
        } else {
          this.error = '';
          this.balancebtn = true;
        }
      } else {
        const amountToBePaid = this.amount_compute;
        
        if (this.amount_discount > amountToBePaid) {
          this.amount_discount = amountToBePaid;
        }
        
        const discountedAmount = amountToBePaid - this.amount_discount;
        
        if (this.amount_paid > discountedAmount) {
          this.amount_paid = discountedAmount;
        }
        
        this.balance = discountedAmount - this.amount_paid;
    
        if (this.balance < 0) {
          this.balancebtn = false;
          this.error = "Amount paid exceeds balance";
        } else {
          this.error = '';
          this.balancebtn = true;
        }
      }
    },
    
    pay(visit,id,name,gender,telephone,balance,patient_id,visit_id,discount){
      this.visitID=visit;
      this.id=id;
      this.name=name;
      this.gender=gender;
      this.telephone=telephone;
      this.amount_paid=balance;
      this.amount_compute = this.amount_paid;
      this.amount_discount=discount;
      this.patient_id=patient_id;
      this.visit_id=visit_id;
      this.$bvModal.show('view-pay')
    },
    
    async addPayment() {
      this.balancebtn=false;
      this.error="Saving Patient Payment";
      let formData = new FormData();
      formData.append("visitID", this.visitID);
      formData.append("patient", this.patient_id);
      formData.append("visit_id", this.visit_id);
      formData.append("payment_option", this.payment_method.id);
      formData.append("payment_type", this.payment_type);
      formData.append("amount_discount",this.amount_discount);
      formData.append("amount_paid", this.amount_paid);
      formData.append("pay_date", this.paydate);
      let url = "/addpayment"; 
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPatientPayments();
          this.$bvModal.hide('view-pay');
          this.balancebtn=true;
          this.error="";
          this.patient="";
          this.visit_id="";
          this.account_balance="";
          this.payment_type="1";
          this.amount_discount="";
          this.amount_paid="";
          this.$toast.success("Patient Payment Added");
        }
      });
    },
    
    // Export to PDF
    exportToPDF() {
      if (this.filteredListLength === 0) {
        this.$toast.warning("No data to export!");
        return;
      }
      
      const printWindow = window.open('', '_blank');
      const currentDate = new Date().toLocaleString();
      const stats = this.statistics;
      
      // Generate table rows
      let tableRows = '';
      this.filteredItems.forEach((item, index) => {
        tableRows += `
          <tr>
            <td style="padding: 8px; border: 1px solid #ddd;">${index + 1}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${this.escapeHtml(item.patient?.patient_id || '')}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${this.escapeHtml(item.patient?.name || '')}<br><small>0${item.patient?.telephone || ''}</small></td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.formatCurrency(item.total_amount)}</td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.formatCurrency(item.prescriptions)}</td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.formatCurrency(item.consumables)}</td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.formatCurrency(item.paid)}</td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.formatCurrency(item.discount)}</td>
            <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${this.formatCurrency(item.balance)}</td>
            <td style="padding: 8px; border: 1px solid #ddd;">${item.visit_date || ''}</td>
          </tr>
        `;
      });
      
      // Get active filters
      const activeFilters = [];
      if (this.appliedFilters.paidMin || this.appliedFilters.paidMax) {
        activeFilters.push(`Paid: ${this.appliedFilters.paidMin || '0'} - ${this.appliedFilters.paidMax || '∞'}`);
      }
      if (this.appliedFilters.discountMin || this.appliedFilters.discountMax) {
        activeFilters.push(`Discount: ${this.appliedFilters.discountMin || '0'} - ${this.appliedFilters.discountMax || '∞'}`);
      }
      if (this.appliedFilters.totalMin || this.appliedFilters.totalMax) {
        activeFilters.push(`Total: ${this.appliedFilters.totalMin || '0'} - ${this.appliedFilters.totalMax || '∞'}`);
      }
      if (this.appliedFilters.balanceMin || this.appliedFilters.balanceMax) {
        activeFilters.push(`Balance: ${this.appliedFilters.balanceMin || '0'} - ${this.appliedFilters.balanceMax || '∞'}`);
      }
      if (this.appliedFilters.patientName) activeFilters.push(`Patient: ${this.appliedFilters.patientName}`);
      if (this.appliedFilters.telephone) activeFilters.push(`Telephone: ${this.appliedFilters.telephone}`);
      
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Patient Payments Report</title>
          <style>
            @media print {
              body { margin: 0; padding: 20px; }
              .no-print { display: none; }
              table { page-break-inside: avoid; }
              thead { display: table-header-group; }
            }
            body {
              font-family: Arial, Helvetica, sans-serif;
              padding: 20px;
              margin: 0;
            }
            .print-header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 10px;
              border-bottom: 2px solid #333;
            }
            .print-header h1 {
              color: #2c3e50;
              margin: 0 0 10px 0;
            }
            .print-header p {
              color: #7f8c8d;
              margin: 5px 0;
            }
            .statistics-box {
              margin-bottom: 20px;
              padding: 15px;
              background-color: #f5f5f5;
              border-radius: 5px;
            }
            .statistics-box table {
              width: 100%;
              border: none;
            }
            .statistics-box td {
              padding: 5px;
              border: none;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
              font-size: 11px;
            }
            th {
              background-color: #34495e;
              color: white;
              padding: 8px;
              border: 1px solid #2c3e50;
              text-align: left;
            }
            td {
              padding: 6px;
              border: 1px solid #ddd;
            }
            tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            .print-footer {
              text-align: center;
              margin-top: 30px;
              padding-top: 20px;
              border-top: 1px solid #ddd;
              font-size: 10px;
              color: #7f8c8d;
            }
            .print-button {
              text-align: center;
              margin-bottom: 20px;
            }
            button {
              background-color: #3498db;
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 5px;
              cursor: pointer;
              font-size: 14px;
              margin: 0 5px;
            }
            .text-right {
              text-align: right;
            }
          </style>
        </head>
        <body>
          <div class="print-button no-print">
            <button onclick="window.print();">🖨️ Print / Save as PDF</button>
            <button onclick="window.close();" style="background-color: #95a5a6;">❌ Close</button>
          </div>
          
          <div class="print-container">
            <div class="print-header">
              <h1>Patient Payments Report</h1>
              <p>Generated on: ${currentDate}</p>
              <p>Period: ${this.datefrom} to ${this.dateto}</p>
            </div>
            
            <div class="statistics-box">
              <h3>Financial Summary</h3>
              <table>
                <tr>
                  <td><strong>Total Records:</strong> ${this.filteredListLength}</td>
                  <td class="text-right"><strong>Total Amount:</strong> ${this.formatCurrency(stats.totalAmount)}</td>
                </tr>
                <tr>
                  <td><strong>Total Service Amount:</strong> ${this.formatCurrency(stats.totalServices)}</td>
                  <td class="text-right"><strong>Total Paid:</strong> ${this.formatCurrency(stats.totalPaid)}</td>
                </tr>
                <tr>
                  <td><strong>Total Prescriptions:</strong> ${this.formatCurrency(stats.totalPrescriptions)}</td>
                  <td class="text-right"><strong>Total Discounts:</strong> ${this.formatCurrency(stats.totalDiscounts)}</td>
                </tr>
                <tr>
                  <td><strong>Total Consumables:</strong> ${this.formatCurrency(stats.totalConsumables)}</td>
                  <td class="text-right"><strong>Total Balance:</strong> ${this.formatCurrency(stats.totalBalance)}</td>
                </tr>
              </table>
              ${activeFilters.length > 0 ? `<p><strong>Active Filters:</strong> ${activeFilters.join(' | ')}</p>` : ''}
            </div>
            
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Patient ID</th>
                  <th>Name / Contact</th>
                  <th>Service Amt</th>
                  <th>Prescription</th>
                  <th>Consumables</th>
                  <th>Paid</th>
                  <th>Discount</th>
                  <th>Balance</th>
                  <th>Visit Date</th>
                </tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="6" style="text-align: right;">Totals:</th>
                  <th style="text-align: right;">${this.formatCurrency(stats.totalPaid)}</th>
                  <th style="text-align: right;">${this.formatCurrency(stats.totalDiscounts)}</th>
                  <th style="text-align: right;">${this.formatCurrency(stats.totalBalance)}</th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
            
            <div class="print-footer">
              <p>This report was generated automatically from the Patient Management System.</p>
              <p>Printed on: ${currentDate}</p>
            </div>
          </div>
        </body>
        </html>
      `);
      
      printWindow.document.close();
      printWindow.focus();
    },
    
    escapeHtml(text) {
      if (!text) return '';
      const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };
      return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }
  },
};
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}

.total-label {
  margin-right: 10px;
}

.total-value {
  font-weight: bold;
  margin-right: 20px;
}
</style>